import type { InputHTMLAttributes } from "react";
import { cx } from "./cx";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Visual error state — pair with Field's `error` for the message. */
  error?: boolean;
  /** Mono/data register (coordinates, numeric entry). */
  mono?: boolean;
}

export function Input({ error = false, mono = false, className, ...rest }: InputProps) {
  return (
    <input
      className={cx("pz-input", error && "pz-input--error", mono && "pz-input--mono", className)}
      aria-invalid={error || undefined}
      {...rest}
    />
  );
}
